import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
export default class ClassifiedsSellerCard extends Component {
  view() {
    const discussion = this.attrs.discussion;
    const user = discussion.user?.();
    if (!user) return null;
    const profileHref = app.route?.user?.(user) || `/u/${user.username?.()}`;
    const joined = user.joinTime?.();
    // Only listings in classifieds tags — not the user's total forum
    // discussion count (which would include unrelated topics).
    const listingsCount = typeof user.classifiedsListingsCount === 'function' ? user.classifiedsListingsCount() : null;
    const lastSeen = user.lastSeenAt?.();
    return m("div", {
      className: "ClassifiedsSellerCard"
    }, m("div", {
      className: "ClassifiedsSellerCard-header"
    }, m("span", {
      className: "ClassifiedsSellerCard-label"
    }, app.translator.trans('flarum-classifieds.forum.seller.title'))), m("a", {
      className: "ClassifiedsSellerCard-body",
      href: profileHref,
      config: m.route.link
    }, m(Avatar, {
      user: user,
      className: "ClassifiedsSellerCard-avatar"
    }), m("div", {
      className: "ClassifiedsSellerCard-info"
    }, m("span", {
      className: "ClassifiedsSellerCard-name"
    }, username(user)), joined && m("span", {
      className: "ClassifiedsSellerCard-meta"
    }, m("i", {
      className: "fas fa-clock",
      "aria-hidden": "true"
    }), ' ', app.translator.trans('flarum-classifieds.forum.seller.member_since', {
      time: humanTime(joined)
    })), typeof listingsCount === 'number' && m("span", {
      className: "ClassifiedsSellerCard-meta"
    }, m("i", {
      className: "fas fa-tag",
      "aria-hidden": "true"
    }), ' ', app.translator.trans('flarum-classifieds.forum.seller.listings', {
      count: listingsCount
    })), lastSeen && m("span", {
      className: "ClassifiedsSellerCard-meta ClassifiedsSellerCard-meta--online"
    }, m("span", {
      className: "ClassifiedsSellerCard-dot"
    }), ' ', app.translator.trans('flarum-classifieds.forum.seller.last_seen', {
      time: humanTime(lastSeen)
    })))));
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ClassifiedsSellerCard', ClassifiedsSellerCard);